import { useEffect } from 'react';

import styles from './modal-components.module.css';
import { useModalContext } from '../modal.context';

export type ModalSkipProps = {
  onSkip: VoidFunction;
};

export const ModalSkip = ({ onSkip }: ModalSkipProps) => {
  const { mountSkipButton } = useModalContext();

  useEffect(mountSkipButton, [mountSkipButton]);

  return (
    <button className={styles.skipButton} onClick={onSkip}>
      skip
    </button>
  );
};
